/**
 * Created by rickborst on 26/04/2017.
 */

import League from 'models/league';
import Team from 'models/team';

class MatchInfo {

    constructor (options = {}) {

        this.league = options.league
            ? new League(options.league)
            : null;
        this.team1 = options.team1
            ? new Team(options.team1)
            : null;
        this.team2 = options.team2
            ? new Team(options.team2)
            : null;
        this.location = options.location || '';
        this.sportType = options.sportType || '';

        return this;
    }
}

export default MatchInfo;


// WEBPACK FOOTER //
// ./src/js/models/asset/matchinfo.js